import DailyMockCategoryFormPage from "./DailyMockCategoryFormPage";

export default function DailyMockCategoryEdit() {
  return (
    <DailyMockCategoryFormPage
      mode="edit"
      pageTitle="Edit Daily Mock Category"
      breadcrumbTitle="Edit Daily Mock Category"
      successMessage="Daily mock category updated successfully"
    />
  );
}
